import { render, staticRenderFns } from "./ShowDescription.vue?vue&type=template&id=62be3d95&scoped=true&"
import script from "./ShowDescription.vue?vue&type=script&lang=js&"
export * from "./ShowDescription.vue?vue&type=script&lang=js&"
import style0 from "./ShowDescription.vue?vue&type=style&index=0&id=62be3d95&prod&lang=scss&scoped=true&"
import style1 from "./ShowDescription.vue?vue&type=style&index=1&id=62be3d95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be3d95",
  null
  
)

export default component.exports